"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPAYMENT_CREDIT_CARD = exports.OTHER_EXPENSE = exports.STORAGE = exports.RETIREMENT_LOANS = exports.CHARITY = exports.DISABLED_FAMILY = exports.CONTRIBUTIONS_TO_FAMILY = exports.NOT_DEDUCTED_CHILD_SUPPORT = exports.NOT_DEDUCTED_ALIMONY = exports.CHILD_EDUCTION = exports.DAYCARE_BABYSITTER = exports.OTHER_INSURANCE = exports.VEHICLE_LEASE = exports.VEHICLE_INSTALLMENTS = exports.INSTALLMENT_LEASE = exports.OTHER_TRANSPORTATION = exports.VEHICLE_INSURANCE = exports.VEHICLE_MAINTENANCE = exports.GASOLINE = exports.NOT_DEDUCTED_DENTAL_INSURANCE = exports.NOT_DEDUCTED_HEALTH_INSURANCE = exports.LIFE_INSURANCE = exports.CONTACTS = exports.GLASSES = exports.VISION_EXPENSES = exports.DENTAL_PRESCRIPTIONS = exports.DENTAL_EXPENSES = exports.MEDICAL_PRESCRIPTIONS = exports.MEDICAL_EXPENSES = exports.TAX_PAYMENTS = exports.RECREATION = exports.CLOTHING = exports.CLEANING_LAUNDRY = exports.HAIR_CUTS = exports.PERSONAL_CARE = exports.GROCERIES = exports.OTHER_UTILITIES = exports.CELL_PHONE = exports.CABLE_PHONE_INTERNET = exports.WATER_SEWER_TRASH = exports.HEAT = exports.ELECTRIC = exports.OTHER_PROPERTY_EXPENSE = exports.TIMESHARE_EXPENSES = exports.HOA_CONDO_FEES = exports.UPKEEP_REPAIRS = exports.PROPERTY_INSURANCE = exports.PROPERTY_TAXES = exports.MORTGAGE_RENT = exports.PROPERTY = void 0;
exports.REPAYMENT_LOAN = exports.REPAYMENT_STUDENT_LOAN = void 0; // Property

exports.PROPERTY = "property";
exports.MORTGAGE_RENT = "mortgageRent";
exports.PROPERTY_TAXES = "propertyTaxes";
exports.PROPERTY_INSURANCE = "propertyInsurance";
exports.UPKEEP_REPAIRS = "upkeepRepairs";
exports.HOA_CONDO_FEES = "hoaCondoFees";
exports.TIMESHARE_EXPENSES = "timeshareExpenses";
exports.OTHER_PROPERTY_EXPENSE = "otherPropertyExpense"; // Utilities

exports.ELECTRIC = "electric";
exports.HEAT = "heat";
exports.WATER_SEWER_TRASH = "waterSewerTrash";
exports.CABLE_PHONE_INTERNET = "cablePhoneInternet";
exports.CELL_PHONE = "cellPhone";
exports.OTHER_UTILITIES = "otherUtilities"; // Household

exports.GROCERIES = "groceries";
exports.PERSONAL_CARE = "personalCare";
exports.HAIR_CUTS = "hairCuts";
exports.CLEANING_LAUNDRY = "cleaningLaundry";
exports.CLOTHING = "clothing";
exports.RECREATION = "recreation"; // Taxes

exports.TAX_PAYMENTS = "taxPayments"; // Health/Medical/Insurance

exports.MEDICAL_EXPENSES = "medicalExpenses";
exports.MEDICAL_PRESCRIPTIONS = "medicalPrescriptions";
exports.DENTAL_EXPENSES = "dentalExpenses";
exports.DENTAL_PRESCRIPTIONS = "dentalPrescriptions";
exports.VISION_EXPENSES = "visionExpenses";
exports.GLASSES = "glasses";
exports.CONTACTS = "contacts";
exports.LIFE_INSURANCE = "lifeInsurance";
exports.NOT_DEDUCTED_HEALTH_INSURANCE = "notDeductedHealthInsurance"; // TODO: > HEALTH_INSURANCE (if its an expense its by default not deducted. duplicative)

exports.NOT_DEDUCTED_DENTAL_INSURANCE = "notDeductedDentalInsurance"; // v2: Adding w/ not deducted pattern
// Transportation

exports.GASOLINE = "gasoline";
exports.VEHICLE_MAINTENANCE = "vehicleMaintenance";
exports.VEHICLE_INSURANCE = "vehicleInsurance";
exports.OTHER_TRANSPORTATION = "otherTransportation";
exports.INSTALLMENT_LEASE = "installmentLease";
exports.VEHICLE_INSTALLMENTS = "vehicleInstallments";
exports.VEHICLE_LEASE = "vehicleLease"; // Other Insurance

exports.OTHER_INSURANCE = "otherInsurance"; // Childcare

exports.DAYCARE_BABYSITTER = "daycareBabysitter";
exports.CHILD_EDUCTION = "childEducation"; // Alimony, Manintenance, Support

exports.NOT_DEDUCTED_ALIMONY = "notDeductedAlimony"; // TODO: ALIMONY (not deducted from paycheck means its redudant to say "not deducted")

exports.NOT_DEDUCTED_CHILD_SUPPORT = "notDeductedChildSupport"; // v2: Adding w/ not deducted pattern
// Contributions

exports.CONTRIBUTIONS_TO_FAMILY = "contributionsToFamily"; // Btw, this is also a not deducted situation even though that's missing from cosnt

exports.DISABLED_FAMILY = "disabledFamily";
exports.CHARITY = "charity"; // Other

exports.RETIREMENT_LOANS = "retirementLoans";
exports.STORAGE = "storage";
exports.OTHER_EXPENSE = "otherExpense"; // Payments to existing debts

exports.REPAYMENT_CREDIT_CARD = "repaymentCreditCard"; // v2, exclude in 106J

exports.REPAYMENT_STUDENT_LOAN = "repaymentStudentLoan"; // v2

exports.REPAYMENT_LOAN = "repaymentLoan"; // v2, exclude in 106J